import script from "./FoundryContractTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundryContractTable.vue?vue&type=script&setup=true&lang=js"

import "./FoundryContractTable.vue?vue&type=style&index=0&id=718066a6&lang=scss"

const __exports__ = script;

export default __exports__